import { render, staticRenderFns } from "./buscador-institucion-snp.vue?vue&type=template&id=2936eb5f&scoped=true&"
import script from "./buscador-institucion-snp.component.ts?vue&type=script&lang=ts&"
export * from "./buscador-institucion-snp.component.ts?vue&type=script&lang=ts&"
import style0 from "./buscador-institucion-snp.vue?vue&type=style&index=0&id=2936eb5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936eb5f",
  null
  
)

export default component.exports